import { useEffect, useRef } from "react"
import { Space, User } from "~/types"
import {
  showParticipantJoinedNotification,
  showParticipantLeftNotification,
} from "~/utils/NotificationUtils"

export type useParticipantNotificationsOptions = {
  space?: Space | null
  user?: User | null
}

export const useParticipantNotifications = ({
  space,
  user: currentUser,
}: useParticipantNotificationsOptions) => {
  const participantsRef = useRef<User[]>([])
  useEffect(() => {
    const prev = participantsRef.current
    const current = [...(space?.users ?? []), ...(space?.guests ?? [])]

    if (prev.length > 0) {
      const prevIds = new Set(prev.map((p) => p.id))
      const joinedBy = current.filter((p) => !prevIds.has(p.id))

      joinedBy.forEach((p) => {
        if (p.id === currentUser?.id) return
        showParticipantJoinedNotification(p, space?.current_timer)
      })
    }

    if (current.length > 0) {
      const currentIds = new Set(current.map((p) => p.id))
      const leftBy = prev.filter((p) => !currentIds.has(p.id))

      leftBy.forEach((p) => {
        if (p.id === currentUser?.id) return
        showParticipantLeftNotification(p, space?.current_timer)
      })
    }

    participantsRef.current = current
  }, [space])
}
